import "./OurStory.module.css";
import MainNavigation from "@/reusable_sections/Header";
import TheWandererBehindTheLens from "./sections/TheWandererBehindTheLens";
import DistributionHubs from "./sections/DistributionHubs";
import AdvisoryCollective from "./sections/AdvisoryCollective";
import ExperienceInquiry from "./sections/ExperienceInquiry";
import MidnightRunnersCollection from "@/reusable_sections/Footer";
export default function OurStoryPage() {
  return <div>
      <MainNavigation />
      <TheWandererBehindTheLens />
      <DistributionHubs />
      <AdvisoryCollective />
      <ExperienceInquiry />
      <MidnightRunnersCollection />
    </div>;
}